const wrapText = (ctx, text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  words.forEach((w) => {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else {
      line = test;
    }
  });
  if (line) lines.push(line);
  return lines;
};

export const generateLightCardImage = (card) =>
  new Promise((resolve) => {
    const W = 1080;
    const H = 1350;
    const c = document.createElement("canvas");
    c.width = W;
    c.height = H;
    const ctx = c.getContext("2d");

    ctx.fillStyle = "#0F766E";
    ctx.fillRect(0, 0, W, H);
    ctx.strokeStyle = "#FBBF24";
    ctx.lineWidth = 4;
    ctx.strokeRect(60, 60, W - 120, H - 120);
    ctx.lineWidth = 1.5;
    ctx.strokeRect(80, 80, W - 160, H - 160);

    ctx.textAlign = "center";
    ctx.fillStyle = "#FCD34D";
    ctx.font = "bold 30px Arial, sans-serif";
    ctx.fillText(card.suit.toUpperCase().split("").join(" "), W / 2, 210);

    // small dandelion mark
    const cx = W / 2, cy = 380, r = 80;
    ctx.strokeStyle = "#FBBF24";
    ctx.lineWidth = 2.5;
    for (let i = 0; i < 20; i++) {
      const a = (i / 20) * Math.PI * 2;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(cx + Math.cos(a) * r, cy + Math.sin(a) * r);
      ctx.stroke();
      ctx.fillStyle = "#FCD34D";
      ctx.beginPath();
      ctx.arc(cx + Math.cos(a) * r, cy + Math.sin(a) * r, 4.5, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.fillStyle = "#D97706";
    ctx.beginPath();
    ctx.arc(cx, cy, 14, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = "#FFFFFF";
    ctx.font = "bold 76px Georgia, serif";
    ctx.fillText(card.front, W / 2, 610);

    ctx.font = "italic 40px Georgia, serif";
    ctx.fillStyle = "rgba(255,255,255,0.9)";
    const lines = wrapText(ctx, card.back, W - 280);
    lines.forEach((l, i) => ctx.fillText(l, W / 2, 730 + i * 60));

    ctx.strokeStyle = "rgba(252, 211, 77, 0.5)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(W / 2 - 100, 1130);
    ctx.lineTo(W / 2 + 100, 1130);
    ctx.stroke();
    ctx.fillStyle = "#FCD34D";
    ctx.font = "bold 24px Arial, sans-serif";
    ctx.fillText("B E   T H E   L I G H T", W / 2, 1180);
    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.font = "italic 24px Georgia, serif";
    ctx.fillText("Dandelion Farm · House of Bloom", W / 2, 1225);

    c.toBlob(resolve, "image/png");
  });
